export default __webpack_public_path__ + "static/media/edit.2696c104.svg";